import React, { useRef, useState } from 'react';
import { useCommonStore } from '../store/CommonStore.localforage';
import ManageAssetReportModal, {
  ManageAssetReportModalData,
} from '../../domain/assetReport/component/popup/ManageAssetReportModal';
import ManageAssetGoalsModal, {
  ManageAssetGoalsModalData,
} from '../../domain/assetGoals/component/popup/ManageAssetGoalsModal';
import ManageAssetPortfolioModal, {
  ManageAssetPortfolioModalData,
} from '../../domain/assetPortfolio/component/popup/ManageAssetPortfolioModal';
import manageAssetPortfolioModal from '../../domain/assetPortfolio/component/popup/ManageAssetPortfolioModal';
import {
  useAppStateManageAssetGoalsModalDataStore,
  useAppStateManageAssetPortfolioModalDataStore,
  useAppStateManageAssetReportModalDataStore,
} from '../store/AppStateStore.zustand';

const CommonHeader = () => {
  const { exportStoreData, importStoreData, clearStoreData } = useCommonStore();
  const hiddenInput = useRef<HTMLInputElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const { manageAssetReportModalData, setManageAssetReportModalData } = useAppStateManageAssetReportModalDataStore();
  const { manageAssetGoalsModalData, setManageAssetGoalsModalData } = useAppStateManageAssetGoalsModalDataStore();
  const { manageAssetPortfolioModalData, setManageAssetPortfolioModalData } =
    useAppStateManageAssetPortfolioModalDataStore();

  const handleDataUploadClick = () => {
    hiddenInput && hiddenInput.current?.click();
  };

  const handleDataDownloadClick = async () => {
    await exportStoreData();
  };

  const handleFileChange: React.ChangeEventHandler<HTMLInputElement> = async (event) => {
    const file = event.target.files && event.target.files.length > 0 && event.target.files[0];
    if (!file || !importStoreData) return;

    try {
      await importStoreData(file);
      window.location.reload();
    } catch (err) {
      alert('오류 발생');
    }
  };

  const handleDataClearClick = async () => {
    await clearStoreData();
    window.location.reload();
  };

  const handleAssetReportClick = () => {
    setManageAssetReportModalData({ isOpen: true, onClose: () => setManageAssetReportModalData(undefined) });
  };

  const handleAssetGoalsClick = () => {
    setManageAssetGoalsModalData({ isOpen: true, onClose: () => setManageAssetGoalsModalData(undefined) });
  };

  const handleAssetPortfolioClick = () => {
    setManageAssetPortfolioModalData({ isOpen: true, onClose: () => setManageAssetPortfolioModalData(undefined) });
  };

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-50 backdrop-blur-sm bg-white/90">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img src="/icon.png" alt="Logo" className="h-8 w-8" />
          <h1 className="text-2xl font-bold text-gray-900 cursor-pointer">HoneymoonSalad</h1>
        </div>
        <nav className="hidden md:flex items-center space-x-2">
          <div className="flex space-x-1">
            <button
              className="text-gray-700 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 px-2 py-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetReportClick}
            >
              <i className="fas fa-wallet mr-0 lg:mr-2"></i>
              <span className="hidden lg:inline">자산</span>
            </button>
            <button
              className="text-gray-700 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 px-2 py-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetGoalsClick}
            >
              <i className="fas fa-bullseye mr-0 lg:mr-2"></i>
              <span className="hidden lg:inline">목표</span>
            </button>
            <button
              className="text-gray-700 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 px-2 py-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetPortfolioClick}
            >
              <i className="fas fa-chart-pie mr-0 lg:mr-2"></i>
              <span className="hidden lg:inline">포트폴리오</span>
            </button>
          </div>
          <div className="border-l border-gray-200 h-6"></div>
          <div className="flex items-center space-x-2">
            <button
              className="text-gray-600 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataDownloadClick}
            >
              <i className="fas fa-download text-lg"></i>
            </button>
            <button
              className="text-gray-600 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataUploadClick}
            >
              <i className="fas fa-upload text-lg"></i>
            </button>
            <button
              className="text-gray-600 hover:text-blue-600 font-medium !rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataClearClick}
            >
              <i className="fas fa-trash text-lg"></i>
            </button>
          </div>
        </nav>

        {/* Hamburger menu button (mobile only) */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-gray-600 hover:text-blue-600 focus:outline-none md:hidden"
        >
          <i className="fas fa-bars text-2xl"></i>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white px-6 pb-4">
          <div className="flex flex-col space-y-1">
            <button
              className="text-gray-700 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 p-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetReportClick}
            >
              <i className="fas fa-wallet mr-2"></i>자산
            </button>
            <button
              className="text-gray-700 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 p-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetGoalsClick}
            >
              <i className="fas fa-bullseye mr-2"></i>목표
            </button>
            <button
              className="text-gray-700 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer transition-all duration-200 p-2 hover:bg-gray-50 flex items-center"
              onClick={handleAssetPortfolioClick}
            >
              <i className="fas fa-chart-pie mr-2"></i>포트폴리오
            </button>
            <div className="border-t border-gray-200 my-2"></div>
            <button
              className="text-gray-600 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataDownloadClick}
            >
              <i className="fas fa-download text-lg mr-2"></i>다운로드
            </button>
            <button
              className="text-gray-600 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataUploadClick}
            >
              <i className="fas fa-upload text-lg mr-2"></i>업로드
            </button>
            <button
              className="text-gray-600 hover:text-blue-600 font-medium rounded-button whitespace-nowrap cursor-pointer p-2 hover:bg-gray-50 transition-all duration-200 flex items-center"
              onClick={handleDataClearClick}
            >
              <i className="fas fa-trash text-lg mr-2"></i>초기화
            </button>
          </div>
        </div>
      )}
      <input
        ref={hiddenInput}
        type={'file'}
        style={{ display: 'none' }}
        accept="application/json"
        onChange={handleFileChange}
      />

      {manageAssetReportModalData && <ManageAssetReportModal {...manageAssetReportModalData} />}
      {manageAssetGoalsModalData && <ManageAssetGoalsModal {...manageAssetGoalsModalData} />}
      {manageAssetPortfolioModalData && <ManageAssetPortfolioModal {...manageAssetPortfolioModalData} />}
    </header>
  );
};

export default CommonHeader;
